import React from 'react';
import { Checkbox, Form } from 'antd';

function CheckInput({
  name, label, rules = [],
}) {
  return (
    <Form.Item
      name={name}
      rules={rules}
      valuePropName="checked"
    >
      <Checkbox>{label}</Checkbox>
    </Form.Item>
  );
}

export default CheckInput;
